var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v(" "+_vm._s(_vm.coinsToString(_vm.amount))),_c('v-icon',{staticStyle:{"color":"inherit","font-size":"inherit","margin-left":"0.2em","padding-bottom":"0.1em"}},[_vm._v("mdi-circle-multiple-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }